/**
 * DirectCellUpdateContext - Context for direct cell updates
 *
 * Allows boolean fields to toggle with single click without entering edit mode.
 * Also used by FK editors to update newRowData for new rows.
 */

import { createContext } from "react";
import type { GridRowId } from "@mui/x-data-grid";

/**
 * Function type for direct cell updates
 */
export type DirectCellUpdateFn = (
  rowId: GridRowId,
  field: string,
  value: unknown,
) => Promise<void>;

/**
 * Context for direct cell updates
 * Used by editors that need to update cells without going through edit mode
 */
export const DirectCellUpdateContext = createContext<DirectCellUpdateFn | null>(
  null,
);
